export { Textarea, textareaVariants, type TextareaProps } from './Textarea'
